import { Injectable } from '@angular/core';
import { AnalyticsEventProvider } from './analytics-event-provider.service';
import { DownloadEvent } from '../events/download-event';

export interface DownloadEventArgs {
  download_text?: string;
  field_name?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AnalyticsDownloadEventProvider extends AnalyticsEventProvider<DownloadEvent> {
  createAndPush(args: DownloadEventArgs): void {
    this.push(
      new DownloadEvent({
        download_text: args.download_text,
        field_name: args.field_name,
      }),
    );
  }
}
